export default __webpack_public_path__ + "static/media/Active_recommendation.12ba8fb5.svg";